import React from 'react';

import { Grid, makeStyles, useTheme } from '@material-ui/core';
import AutoCard from 'components/AutoCard';
import styles, { overrideCardGraph } from './styles';

interface EnvironmentGraphCardProps {
  children?: React.ReactNode;
}

const EnvironmentGraphCard = ({ children }: EnvironmentGraphCardProps) => {
  const classes = makeStyles(styles())();
  const { breakpoints } = useTheme();

  return (
    <Grid item className={classes.containerCard}>
      <AutoCard overrideClasses={overrideCardGraph(breakpoints)}>
        <Grid container>
          <Grid container className={classes.containerGraph}>
            {children}
          </Grid>
        </Grid>
      </AutoCard>
    </Grid>
  );
};

export default EnvironmentGraphCard;
